<template>
  <div>
    <my-header/>

    <div class="derby-box">

      <b-breadcrumb>
        <b-breadcrumb-item :to="{name:'derby_list'}">Скачки</b-breadcrumb-item>
      </b-breadcrumb>

      <h2>Скачки {{ derbyId }}</h2>

      <div class="section-container">
        <side-nav :menuItems="menuItems" class="side-nav"></side-nav>

        <div class="content-box">
          <router-view></router-view>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import MyHeader from '../Header.vue';
import SideNav from '../SideNav.vue';

export default {
  name: 'Derby',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    derbyId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menuItems() {
      const items = [
        {
          title: 'Информация',
          route: {name: 'derby_info'},
          exact: true,
        },
        {
          title: 'Лиги',
          route: {name: 'derby_leagues'},
        },
        {
          title: 'Заезды',
          route: {name: 'derby_races'},
        },
      ];

      return items;
    },
  },
};
</script>

<style scoped>
.derby-box {
  margin-left: 1rem;
  max-width: 600px;
}

.section-container {
  display: flex;
  align-items: flex-start;
}

.side-nav {
  margin-right: 2em;
  background-color: rgb(242, 247, 251);
}
</style>
